class UpdateStatusWithComment {
	constructor(formElement) {
		this.formElement = formElement;
		this.commentField = this.formElement.querySelector('textarea');

		const status_button = this.formElement.querySelector('button.status');

		if (status_button) {
			status_button.addEventListener('change', () => {
				this.commentField.required =
					this.formElement.querySelector('li.selected').dataset.requireComment;
			});
		}
	}
}

export { UpdateStatusWithComment };
